module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/58FfIl1l1jcywEw3rJ4ql1-ddc684b11f1d7b04fe4ad430ea103aca.jpg";